import { Maybe } from "graphql/jsutils/Maybe";
import { useMemo } from "react";
import { useGetMeQuery } from "../graphql/generated/schema-types";
import { AppUserSettings } from "../interfaces/AppUserSettings";

export const useGetUserSettings = () => {
  const { data } = useGetMeQuery({
    fetchPolicy: "cache-only",
  });
  const userSettings: Maybe<AppUserSettings> = useMemo(() => {
    // Try GraphQL data first (source of truth)
    const graphqlSettings = JSON.parse(
      data?.me?.setting?.settingsJson ?? "null",
    );

    if (graphqlSettings) return graphqlSettings;

    // Fallback to localStorage (prevents theme flash while cache warms)
    try {
      const localTheme = localStorage.getItem("theme");
      if (localTheme) {
        return { theme: JSON.parse(localTheme) } as AppUserSettings;
      }
    } catch (e) {
      console.error("Failed to parse localStorage theme:", e);
    }

    return null;
  }, [data?.me?.setting?.settingsJson]);

  return userSettings;
};
